import script from "./BotTest.vue?vue&type=script&setup=true&lang=js"
export * from "./BotTest.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__